var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"QrLink"}},[_c('h2',[_vm._v(" Откройте сайт с телефона ")]),_c('img',{attrs:{"src":require("../assets/img/qrHeritage.gif")}})])}
var staticRenderFns = []

export { render, staticRenderFns }